import { AddressTypes } from '@models';
import { GetCountriesData } from '@shared';
import { LatinLettersTooltip } from '../components/addresses/city-select-international/city-select.constants';
import { CountryRecipientPayerConfig, DefaultCountryPhoneConfig } from '../international-invoice.constants';

// Slovakia
export const SK: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  ...CountryRecipientPayerConfig,
  CityTooltip: LatinLettersTooltip,
  RecipientSpotSelectionAvailable: true,
  RecipientRegistrationAddressRequired: true,
  RecipientPostboxAvailable: true,
  DisplayRecipientRegistrationAddressFor: [AddressTypes.WAREHOUSE, AddressTypes.POSTBOX],
  RecipientPayerAllowed: true,
};
